export default __webpack_public_path__ + "static/insta2@2x-345e778dcbb47e8068d9f68aace45df1.jpg";